import React from "react"
import { IDocument } from "../firebaseTypes"
import TagO1EB1DocModal from "../components/O1EB1/TagO1EB1DocModal"

export interface ITagO1EB1ModalContext {
  openModalState: boolean,
  openModal: () => any,
  closeModal: () => any,
}

const defaultValues: ITagO1EB1ModalContext = {
  openModalState: false,
  openModal: () => { },
  closeModal: () => { },
}

const context = React.createContext(defaultValues)

export function useTagO1EB1ModalContext() {
  return React.useContext(context)
}

export const TagO1EB1ModalContextProvider: React.FC<{
  document: IDocument
}> = (props) => {
  const [open, setOpen] = React.useState(false);

  const openModal = React.useCallback(() => {
    setOpen(true)
  }, [])

  const closeModal = React.useCallback(() => {
    setOpen(false)
  }, [])

  return <context.Provider value={{
    openModalState: open,
    closeModal,
    openModal
  }}>
    <TagO1EB1DocModal document={props.document} />
    {props.children}
  </context.Provider>
}